import React from 'react';

import { EmailSupportLink } from './email-support-link';

import { HelpScout } from '../util/helpscout-beacon';

export const PermissionMessage = () => (
  <div className="u-padding-xl u-textAlign-center u-margin-0Auto">
    You do not have permission to view this. <br />
    If you believe this is in error, either use{' '}
    <span
      role="presentation"
      className="typo-link"
      onClick={() => HelpScout.beacon.navigate('/ask/')}
    >
      our chat
    </span>
    , or contact <EmailSupportLink />.
  </div>
);
